// use to fix for prices that are too large it overflows
const resizeOverflowingPrice = (price: string) => {
  let sizeOfFont = "";

  if (price.length >= 8) {
    sizeOfFont = "23px";
  }
  if (price.length > 9) {
    sizeOfFont = "20px";
  }

  if (price.length > 10) {
    sizeOfFont = "18px";
  }
  return sizeOfFont;
};

export default resizeOverflowingPrice;
